import React, { FC, useEffect, useState } from "react"
import { Form, Modal, Select } from "antd"
import { useStore } from "stores/utils/use-store"
import { SubmitCancelButtons, FormElement } from "components"
import { createTransactionBuffPlay } from "domains/accountsBuffPlay/api/transactions-BuffPlay.call"
import { notifications } from "notifications"

export const AddBonusBuffPlayComponent: FC<{
  visible: boolean;
  onClose: () => void;
  accountId: string;
  onSubmit?: (el: { name: string; amountUsd: number, type: number }) => void;
}> = ({ visible, onClose, accountId, onSubmit }) => {
  const { dataStore: { accountDetailsStoreBuffPlay, accountTransactionsStoreBuffPlay } } = useStore()
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (!accountTransactionsStoreBuffPlay.availableTypes) {
      accountTransactionsStoreBuffPlay.getTransactionBuffPlayTypes().then()
    }
    accountTransactionsStoreBuffPlay.getGamesBuffPlay().then()
  }, [])

  const onFinishHandler = async(el: { name: string; amountUsd: number, type: number }) => {
    setIsSubmitting(true)
    try {
      await createTransactionBuffPlay({ ...el, accountId, currency: "USD" })
      onClose()
      await accountDetailsStoreBuffPlay.getAccountDetailsById(accountId)
    } catch (e) {
      notifications.error("Failed to create transaction. Please try again.")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal visible={visible} title="Create a Transaction" footer={null} onCancel={() => onClose()}>
      <a
        style={{ marginBottom: "15px", display: "inline-block" }}
        href="https://fulcrumrocks.atlassian.net/wiki/spaces/BUFF/pages/649101317/Transaction+Types"
      >
        Documentation link
      </a>
      <Form onFinish={onSubmit || onFinishHandler}>
        {accountTransactionsStoreBuffPlay.availableTypes && (
          <Form.Item
            label="Transaction type"
            name="type"
            rules={[
              {
                required: true,
                message: "Please select type!",
              },
            ]}
          >
            <Select>
              {Object.entries(accountTransactionsStoreBuffPlay.availableTypes).map((item, id) => (
                <Select.Option value={item[1]} key={id}>
                  {item[0] + 1} - {item[1]}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {accountTransactionsStoreBuffPlay.availableGames && (
          <Form.Item
            label="Game Id"
            name="gameId"
            initialValue=""
            rules={[
              {
                required: false,
                message: "Please select type!",
              },
            ]}
          >
            <Select>
              {accountTransactionsStoreBuffPlay.availableGames.data.map((item, id) => {
                return (
                  <Select.Option value={item.id} key={id}>
                    {item.name}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
        )}
        <FormElement
          type="inputNumber"
          label="Transaction Amount (USD)"
          name="amountUsd"
          required
          props={{ style: { width: "100%" } }}
        />

        <FormElement
          type="input"
          label="Device Id"
          name="deviceId"
          initialValue=""
          props={{ style: { width: "100%" } }}
        />
        <Form.Item label="Platform" name="platform">
          <Select allowClear placeholder="Select platform (optional)">
            <Select.Option value="ANDROID">ANDROID</Select.Option>
            <Select.Option value="IOS">IOS</Select.Option>
          </Select>
        </Form.Item>
        <FormElement
          type="text"
          label="Description"
          name="description"
          required
          props={{ style: { width: "100%" } }}
        />
        <SubmitCancelButtons onClose={onClose} isLoading={isSubmitting} />
      </Form>
    </Modal>
  )
}
